import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.732 2.815H3.998a.27.27 0 00-.27.27v9.867c0 .149.121.27.27.27h8.064c.149 0 .27-.121.27-.27V4.414a1.6 1.6 0 00-1.6-1.6zm-6.734-.8h6.734a2.4 2.4 0 012.4 2.4v8.537c0 .59-.48 1.07-1.07 1.07H3.998a1.07 1.07 0 01-1.07-1.07V3.085c0-.591.48-1.07 1.07-1.07z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.298 4.873V2.547h.8v2.126h2.232v.8H9.898a.6.6 0 01-.6-.6zM4.941 7.202c0-.221.18-.4.4-.4h2a.4.4 0 010 .8h-2a.4.4 0 01-.4-.4zM4.941 9.402c0-.221.18-.4.4-.4h4a.4.4 0 010 .8h-4a.4.4 0 01-.4-.4zM4.941 11.602c0-.221.18-.4.4-.4h4a.4.4 0 010 .8h-4a.4.4 0 01-.4-.4z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }));
}
export default SvgComponent;